import axios from "axios";

export function getAllClassEndType() {
  return axios.get(process.env.VUE_APP_API_URL + "ClassEndType/getall");
}
